module.exports = __webpack_public_path__ + "img/become3.88ef4432.png";